import * as React from 'react'
import { Context } from './provider'

export function useConfig<
	Results extends readonly unknown[] = readonly unknown[],
>(keys: string[]) {
	const client = React.useContext(Context)

	if (client === null) {
		throw new Error('No ConfigClient set, use ConfigProvider to set one')
	}

	const { entry } = client

	if (entry.status === 'error') {
		throw Error('failed to load config')
	}

	// If a response was successful, return
	if (entry.status === 'loaded') {
		return client.read<Results>(keys)
	}

	throw entry.promise
}
